import { useContext } from 'react'
import {
  LightboxContext,
  ILightboxContext,
} from '../providers/LightboxProvider'

export default function useLightbox(): ILightboxContext {
  return useContext<ILightboxContext>(LightboxContext)
}
